import React, { createContext, useContext } from 'react';

/**
 * Navigasi antar-tab di dalam shell dashboard (bottom navigation berbasis index).
 * Memungkinkan aksi cepat di Beranda berpindah ke tab lain (mis. "Statistik")
 * berdasarkan `key` tab, tanpa mengetahui index-nya.
 */
export interface TabInfo {
  key: string;
  label: string;
  icon?: React.ReactNode;
  /** Angka lencana (mis. jumlah approval menunggu). */
  badge?: number;
}

interface TabNavContextValue {
  goToTab: (key: string) => void;
  /** Buka sidebar navigasi lengkap (dipakai tombol "Lainnya"). */
  openMenu: () => void;
  /** Daftar tab yang tampil di shell dashboard (dipakai breadcrumb, quick menu, dsb.). */
  tabs: TabInfo[];
  /** Index tab yang sedang aktif; -1 jika di luar shell dashboard. */
  activeIndex: number;
}

const TabNavContext = createContext<TabNavContextValue>({
  goToTab: () => {},
  openMenu: () => {},
  tabs: [],
  activeIndex: -1,
});

export const TabNavProvider: React.FC<{
  goToTab: (key: string) => void;
  openMenu?: () => void;
  tabs?: TabInfo[];
  activeIndex?: number;
  children: React.ReactNode;
}> = ({ goToTab, openMenu = () => {}, tabs = [], activeIndex = -1, children }) => (
  <TabNavContext.Provider value={{ goToTab, openMenu, tabs, activeIndex }}>
    {children}
  </TabNavContext.Provider>
);

export function useTabNav(): TabNavContextValue {
  return useContext(TabNavContext);
}
